import React, { useState, useEffect } from "react";
import { Spinner } from "react-bootstrap";
import { useLocation } from "react-router-dom";

import Modal from "./../../shared/Modal/";
import { ReactComponent as Visible } from "./../../../public/visible.svg";
import { ReactComponent as Invisible } from "./../../../public/invisible.svg";

export default (props) => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const client_id = params.get("client_id");

  const [loginParams, setLoginParams] = useState({
    email: "",
    password: "",
    remember_me: true,
  });
  const [errors, setErrors] = useState([]);
  const [loggingIn, setLoggingIn] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const rootElement = document.getElementById("root");
    rootElement?.classList.add("overflow-hidden");
    return () => rootElement?.classList.remove("overflow-hidden");
  }, []);

  const setLoginParamsEvent = (e) =>
    setLoginParams({
      ...loginParams,
      [e.target.name]: e.target.value,
    });

  const handleLogin = async (e) => {
    try {
      setLoggingIn(true);
      e.stopPropagation();
      e.preventDefault();
      await props.onLogin(loginParams, client_id);
    } catch (error) {
      setErrors(error);
    } finally {
      setLoggingIn(false);
    }
  };

  const togglePasswordVisibility = () => setVisible(!visible);

  return (
    <Modal id="login_modal" modaltitle="Login" onCancel={props.onCancel}>
      <form className="hv-form" onSubmit={handleLogin}>
        <div className="form-group">
          <input
            className="hv-input form-control"
            value={loginParams.email}
            onChange={setLoginParamsEvent}
            name="email"
            placeholder="Email"
          />
        </div>
        <div className="form-group position-relative">
          <input
            className="hv-input form-control password-field"
            value={loginParams.password}
            onChange={setLoginParamsEvent}
            name="password"
            placeholder="Password"
            type={visible ? "text" : "password"}
          />
          <a href="/forgot_password">
            <small className="form-text forget-password">
              Forgot password?
            </small>
          </a>
          {visible ? (
            <Visible
              className="passwordVisibility"
              onClick={togglePasswordVisibility}
            />
          ) : (
            <Invisible
              className="passwordVisibility"
              onClick={togglePasswordVisibility}
            />
          )}
        </div>
        <div id="login_errors">
          {errors.map((a) => (
            <div className="alert alert-danger" role="alert">
              {a.message}
            </div>
          ))}
        </div>
        <div id="login_actions" className="text-center">
          <button className="btn btn-primary mb-2" type="submit">
            {loggingIn ? (
              <>
                <Spinner
                  as="span"
                  size="sm"
                  animation="border"
                  variant="light"
                  style={{ marginRight: 20 }}
                />
                <small>Logging in...</small>
              </>
            ) : (
              "Login now"
            )}
          </button>
          <p className="mt-2 text-dark">
            Don't have an account? <a href="/signup">Sign up here</a>!
          </p>
        </div>
      </form>
    </Modal>
  );
};
